const questionParsers = {
    'TextModule': (q) => ({ 
        text: q.text 
    }),
    'MovieplayerModule': (q) => ({ 
        video: q.movieFilename,
        fullscreen: q.fullscreen,
        hideControls: q.hideControls
    }),
    'MultipleChoiceModule': (q) => ({
        text:  q.questionText,
        image: q.questionImage,
        backgroundImage: q.backgroundImage,
        itemsPerLine: q.itemsPerLine,
        choices: q.choices.map((v) => ({
            id: v.id, 
            text: v.selectionText, 
            image: v.answerImage, 
            isCorrect: v.isCorrect 
        }))
    }),
    'TowerOfHanoiModule': (q) => ({
        title: q.title,
        code: q.code,
        choices: q.choices,
    }),
    'CardSortingModule': (q) => ({
        title: q.title,
        code: q.code,
        choices: q.choices,
    }),
    'BalloonAnalogRiskTaskModule': (q) => ({
        title: q.title,
        code: q.code,
        choices: q.choices,
    }),
    'SliderModule': (q) => {
        let text = q.questionText.replace(/\<(.*?)\>/g, ""), title = q.title;

        let titleMatches = text.match(/\{(.*?)\}/);
        if (titleMatches) {
            title = titleMatches[1];
            text = text.replace(titleMatches[0], "");
        }

        return {
            id: q.id,
            code: q.code,
            title: title,
            text: text,
            valueStart: q.valueStart,
            valueEnd: q.valueEnd,
            stepCount: q.stepCount
        }
    },
}

export default function() {

    function parse(assignment)
    {
        let data = {
            code: assignment.code,
            title: assignment.title,
            submit: !assignment.noSubmit,
            maxNumberOfCompletions: assignment.maxNumberOfCompletions,

            meta: assignment.assignmentMetas || {},
            questions: []
        };

        let question, collection;
        for (let aq of assignment.assignmentQuestions) {
            question = parseQuestion(aq.question, assignment);

            if (!question) {
                console.warn('[skipping] Could not parse type '+ aq.question.moduleName);
                continue;
            }

            question.index = aq.index;

            if (aq.collection) {
                if (aq.collection !== collection) {
                    collection = aq.collection;
                    data.questions.push([]);
                }

                data.questions[data.questions.length - 1].push(question);
            } else {
                data.questions.push([question]);
            }
        }

        data.questions.forEach(q => q.sort((a,b) => a.index - b.index));
        data.questions.sort((a,b) => a[0].index - b[0].index);

        return data;
    }

    function parseQuestion(question, assignment) {
        let parser = questionParsers[question.moduleName];
        if (!parser)
            return undefined;

        let data = {
            id    : question.id,
            code  : question.code,
            module : question.questionType.module,
            grading: question.questionType.gradingMethod,
            title : question.title,
            hint  : question.hint,
            explanation: question.explanation
        }

        return Object.assign(data, parser(question, assignment));
    }

    return { parse }
}
